'use es6';

import { createSelector } from 'reselect';
import get from 'transmute/get';
import I18n from 'I18n';
import { shouldIncludeDeleted, formatCustomFormFields, getRoundRobinUserIdToBook } from 'MeetingsLib/utils/utils';
import { getHubSpotUtk } from 'MeetingsLib/utils/analytics';
import { LINK_TYPES, MEETING_TYPES } from 'MeetingsBase/constants/enums';
import { getRecaptchaEnabled } from './BookInfoSelectors';
export var getSlug = function getSlug(state) {
  return get('userSlug', state);
};
export var getCurrentTime = get('currentTime');
export var getEmbedded = get('embedded');
export var getMeetingChangeId = get('meetingChangeId');
var getParentPageHSAnalyticsInfo = get('parentPageHSAnalyticsInfo');

function getUtkToPass(embedded, parentPageHSAnalyticsInfo) {
  if (!parentPageHSAnalyticsInfo) {
    return getHubSpotUtk();
  }

  var parentHubspotUtk = parentPageHSAnalyticsInfo.parentHubspotUtk;
  return embedded && parentHubspotUtk ? parentHubspotUtk : getHubSpotUtk();
}

function addParentCosPageUrl(params, parentPageHSAnalyticsInfo) {
  if (!parentPageHSAnalyticsInfo) {
    return params;
  }

  var parentCosPageUrl = parentPageHSAnalyticsInfo.parentPageUrl;

  if (parentCosPageUrl) {
    return Object.assign({}, params, {
      parentCosPageUrl: parentCosPageUrl
    });
  }

  return params;
}

export var getFetchAvailabilityQueryParams = function getFetchAvailabilityQueryParams(params) {
  return createSelector([getSlug, getCurrentTime, getEmbedded, getParentPageHSAnalyticsInfo], function (slug, now, embedded, parentPageHSAnalyticsInfo) {
    var requestParams = {
      slug: slug,
      now: now,
      includeInactiveLink: shouldIncludeDeleted(params),
      hubspotUtk: getUtkToPass(embedded, parentPageHSAnalyticsInfo),
      location: window.location.host
    };
    requestParams = addParentCosPageUrl(requestParams, parentPageHSAnalyticsInfo);
    var email = get('email', params);

    if (email) {
      requestParams = Object.assign({}, requestParams, {
        email: email
      });
    }

    return requestParams;
  });
};
export var getCreateMeetingQueryParams = function getCreateMeetingQueryParams(state) {
  var trackingParams = state.trackingParams,
      embedded = state.embedded,
      parentPageHSAnalyticsInfo = state.parentPageHSAnalyticsInfo,
      userSlug = state.userSlug;
  var utk = getUtkToPass(embedded, parentPageHSAnalyticsInfo);
  var requestParams = Object.assign({}, trackingParams.compact(), {
    hubspotUtk: utk,
    slug: userSlug
  });
  requestParams = addParentCosPageUrl(requestParams, parentPageHSAnalyticsInfo);
  return requestParams;
};
export var getCreateMeetingBodyData = function getCreateMeetingBodyData(_ref) {
  var duration = _ref.duration,
      dateTime = _ref.dateTime;
  return function (state) {
    var event = state.bookingLifecycle.event,
        _state$bookInfo = state.bookInfo,
        offline = _state$bookInfo.offline,
        allUsersBusyTimes = _state$bookInfo.allUsersBusyTimes,
        linkType = _state$bookInfo.linkType,
        bufferTime = _state$bookInfo.bufferTime,
        legalConsentEnabled = _state$bookInfo.customParams.legalConsentEnabled,
        legalConsentResponses = state.legalConsentResponses,
        recaptchaToken = state.recaptcha.token,
        userTimezone = state.userTimezone,
        formState = state.formState;
    var recaptchaEnabled = getRecaptchaEnabled(state);
    var formFields = formatCustomFormFields(formState.customFormFields);
    var body = {
      firstName: formState.firstName,
      lastName: formState.lastName,
      email: formState.email,
      formFields: formFields,
      offline: offline,
      locale: I18n.locale,
      timezone: userTimezone,
      duration: duration,
      startTime: dateTime
    };

    if (legalConsentEnabled) {
      body.legalConsentResponses = legalConsentResponses.toJS();
    }

    if (recaptchaEnabled) {
      body.recaptchaToken = recaptchaToken;
    }

    if (linkType === LINK_TYPES.get(MEETING_TYPES.ROUND_ROBIN)) {
      var _getRoundRobinUserIdT = getRoundRobinUserIdToBook(event, allUsersBusyTimes, bufferTime),
          chosenUserId = _getRoundRobinUserIdT.chosenUserId,
          allUserIds = _getRoundRobinUserIdT.allUserIds;

      body.likelyAvailableUserId = chosenUserId;

      if (allUserIds) {
        body.likelyAvailableUserIds = allUserIds;
      }
    }

    return body;
  };
};
export var buildMeetingRescheduleRequestBody = function buildMeetingRescheduleRequestBody(_ref2) {
  var dateTime = _ref2.dateTime,
      duration = _ref2.duration;
  return function (state) {
    var meetingRescheduleRequest = {
      startTime: dateTime,
      endTime: dateTime + duration,
      slug: getSlug(state),
      meetingChangeId: getMeetingChangeId(state)
    };
    return meetingRescheduleRequest;
  };
};